import InstrumentInstanceModel from "@/models/lab/InstrumentInstanceModel";
import LabServiceCollection from "@/collections/LabServiceCollection";
import InstrumentCollection from "./InstrumentCollection";

export default class InstrumentInstanceCollection extends LabServiceCollection {
  model() {
    return InstrumentInstanceModel;
  }

  getInstruments() {
    const collection = new InstrumentCollection();

    if(this.length) {
      this.each((instance) => {
        const instrument = instance.getInstrument();

        if(instrument) {
          collection.add(instrument);
        }
      });
    }
    
    return collection;
  }

}
